/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notification_Category_Not_ApplicableInputs */

const es_co2_error_notification_category_not_applicable = /** @type {(inputs: Error_Notification_Category_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta categoría no está disponible para tu empresa.`)
};

/**

* @param {Error_Notification_Category_Not_ApplicableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_notification_category_not_applicable = /** @type {((inputs?: Error_Notification_Category_Not_ApplicableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notification_Category_Not_ApplicableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_notification_category_not_applicable(inputs)
});